import helpers from '../tacHelpers';
import _ from 'lodash';
import { replace } from '../replace';

function hide(item) {
  return { ...item, hidden: true, items: (item.items || []).map(hide) };
}

export default function hideItem(model, item) {
  const parent = helpers.getParent(model, item);

  if (!parent) {
    return false;
  }

  const newParent = {
    ...parent,
    items: parent.items.filter(i => i.itemid !== item.itemid),
  };
  const hiddenItem = hide(item);

  newParent.items.push(hiddenItem);

  if (parent === model) {
    return newParent;
  } else {
    const out = _.cloneDeep(model);
    replace(out.items, newParent);
    return out;
  }
}
